import __request__ from "routing/request";
export function listConfigurations(sort = "name", page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", "/sidecar/configurations", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function createConfiguration(JSONbody) {
  return __request__("POST", "/sidecar/configurations", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function renderConfiguration(JSONbody) {
  return __request__("POST", "/sidecar/configurations/render/preview", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function renderConfigurationBysidecarIdAndconfigurationId(sidecarId, configurationId) {
  return __request__("GET", `/sidecar/configurations/render/${sidecarId}/${configurationId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function validateConfiguration(configuration) {
  return __request__("POST", "/sidecar/configurations/validate", configuration, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteConfiguration(id) {
  return __request__("DELETE", `/sidecar/configurations/${id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function updateConfiguration(id, JSONbody) {
  return __request__("PUT", `/sidecar/configurations/${id}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getConfigurations(id) {
  return __request__("GET", `/sidecar/configurations/${id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getConfigurationSidecars(id) {
  return __request__("GET", `/sidecar/configurations/${id}/sidecars`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function copyConfiguration(id) {
  return __request__("POST", `/sidecar/configurations/${id}/${name}`, null, {}, {
    "Accept": ["application/json"]
  });
}
